/**
 *  Get list of restaurants
 */
export const REST_LIST = 'REST_LIST';
/**
 * Get user account data from API.
 */
export const GET_ACCOUNT_DATA = 'GET_ACCOUNT_DATA';
/**
 * Set user data to store.
 */
export const SET_USER = 'SET_USER';
/**
 * Update user data to API.
 */
export const SEND_ACCOUNT_DATA = 'SEND_ACCOUNT_DATA';

export default {
  REST_LIST,
  SET_USER,
  GET_ACCOUNT_DATA,
  SEND_ACCOUNT_DATA,
};



// WEBPACK FOOTER //
// ./src/apps/desktop/store/types.js